<template>
    <ModalWrapper
        v-model="modal"
        :persistent="anyReportLoading"
        :loading="reportParametersLoading"
        class="report-modal"
    >
        <template v-slot:title>
            {{ report.reportName }}
        </template>
        <template v-if="!reportParametersLoading">
            <report-parameters-form
                v-model="reportParametersValid"
                :report-id="report.reportId"
                :disabled="anyReportLoading"
                :_params="reportParameters"
                @change-params="reportParameters = $event"
            />
        </template>
        <template v-if="!reportParametersLoading" v-slot:btns>
            <v-btn
                v-if="canLoadPdf"
                :loading="reportLoading['PDF']"
                :disabled="reportLoading['PDF'] || !reportParametersValid"
                variant="flat"
                @click="download('PDF')"
            >
                PDF
                <v-icon icon="mdi-file-pdf-box" end />
            </v-btn>
            <v-btn
                :loading="reportLoading['Excel']"
                :disabled="reportLoading['Excel'] || !reportParametersValid"
                variant="flat"
                @click="download('Excel')"
            >
                Excel
                <v-icon icon="mdi-file-excel" end />
            </v-btn>
        </template>
    </ModalWrapper>
</template>

<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'
    import ReportParametersForm from '~src/components/account/reports/ReportParametersForm.vue'
    import {clone} from '@/utils/helpers'

    @Component({
        components: {ReportParametersForm},
    })
    export class ReportModal extends Vue {
        modal = false
        report = {}
        reportParameters = {}
        reportParametersLoading = false
        reportParametersValid = true
        reportLoading = {
            Excel: false,
            PDF: false,
        }

        async loadReportParameters(report) {
            this.report = report
            this.reportParametersLoading = true
            this.modal = true
            try {
                this.reportParameters = (
                    await this.$api.reportParameters.get({reportId: report.reportId})
                ).reportParameters
                this.reportParametersLoading = false
            } catch (e) {
                this.$toast.error(this.$t('error_message.load_error'))
                this.modal = false
            }
        }

        async download(fileType) {
            const reportParameters = clone(this.reportParameters).map(p => {
                delete p.multiselect

                if (p.value === '') {
                    delete p.value
                }

                return p
            })

            reportParameters.forEach(el => {
                if (el.name === 'DateForFixedDateRate')
                    el.value = this.$dateFns.format(new Date(el.value).setHours(23, 59), 'yyyy-MM-dd HH:mm')
                if (el.name === 'PaymentMethod' && this.report.reportId === 'Prestige_Customer_Statement_Report') {
                    el.value = el.value?.flat()
                }
            })
            this.reportLoading[fileType] = true
            try {
                await this.$api.report.post({
                    reportId: this.report.reportId,
                    fileType,
                    reportParameters,
                })
            } catch (e) {
                this.$toast.error(this.$t('error_message.load_error'))
            } finally {
                this.reportLoading[fileType] = false
            }
        }

        get canLoadPdf() {
            return true
        }

        get anyReportLoading() {
            return this.reportLoading ? !!Object.values(this.reportLoading).find(loading => loading) : false
        }

        get showSecondaryCloseBtn() {
            return true
        }
    }

    export default ReportModal
</script>
